import { get } from "lodash/fp";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import EyeIcon from "@rsuite/icons/legacy/Eye";
import EyeSlashIcon from "@rsuite/icons/legacy/EyeSlash";
import {
  Button,
  ButtonToolbar,
  Container,
  Content,
  FlexboxGrid,
  Form,
  Message,
  Panel,
  Schema,
  InputGroup,
} from "rsuite";
import {
  AuthServices,
  loginInterface,
} from "../../../core/services/AuthServices";
import { UserServices } from "../../../core/services/UserServices";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { setMenu } from "../../../redux/menu";
import "./Login.css";
import { httpStatusArr, roleObjArr } from "../../../core/config/AppConstants";
import { ContentRoutes, GlobalRoutes } from "../../../navigation/NavConstant";

export function Login() {
  const [formValue, setFormValue] = useState<loginInterface>({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  const handleChange = () => {
    setVisible(!visible);
  };

  async function login(valid: boolean, event: any) {
    try {
      setLoading(true);
      if (valid) {
        let res = await AuthServices.login(formValue);
        localStorage.setItem("authToken", get("data.data.token", res));
        localStorage.setItem(
          "refreshToken",
          get("data.data.refresh_token", res)
        );
        localStorage.setItem(
          "tokenExpiresAt",
          get("data.data.token_expires_at", res)
        );
        localStorage.setItem(
          "refreshTokenExpiresAt",
          get("data.data.refresh_token_expires_at", res)
        );
        let userMeDetail = await UserServices.getLoggedInUserDetail();
        if (
          userMeDetail &&
          userMeDetail.data &&
          userMeDetail.data.status === httpStatusArr.ok
        ) {
          UtilityServices.setLoggedInUserDetails(userMeDetail.data.data);
        }
        dispatch(setMenu(get("data.data.menus", userMeDetail)));
        navigate(getPageAfterLogin());
      }
      setLoading(false);
    } catch (error: any) {
      setError(get("message", error));
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  function getPageAfterLogin() {
    const userRole = UtilityServices.getLoggedInUser("roles");
    let redirectUrl = ContentRoutes.DASHBOARD;
    if (userRole.length > 0) {
      switch (userRole[0]["id"]) {
        case roleObjArr.store_admin.id:
          redirectUrl = ContentRoutes.ORDERS;
          break;
        case roleObjArr.campaign_manager.id:
          redirectUrl = ContentRoutes.CAMPAIGNS;
          break;
      }
    }
    return redirectUrl;
  }

  useEffect(() => {
    if (localStorage.getItem("authToken")) {
      navigate(ContentRoutes.DASHBOARD);
    }
  }, []);

  const model = Schema.Model({
    username: Schema.Types.StringType().isRequired(
      t("REQUIRED", {
        field: t("USERNAME").toLowerCase(),
      })
    ),
    password: Schema.Types.StringType().isRequired(
      t("REQUIRED", {
        field: t("PASSWORD").toLowerCase(),
      })
    ),
  });

  return (
    <div className="show-fake-browser login-page login">
      <Container className="container">
        <Content>
          <FlexboxGrid justify="center">
            <FlexboxGrid.Item colspan={6} className="login-bx">
              <Panel header={<h3 className="text-center">{t("LOGIN")}</h3>}>
                <Form
                  fluid
                  model={model}
                  onSubmit={login}
                  onChange={(value: any) => setFormValue(value)}
                >
                  <Form.Group>
                    <Form.Control
                      name="username"
                      placeholder="Username or Email"
                    />
                  </Form.Group>
                  <Form.Group>
                    <div className="inputgroupPassword">
                      <Form.Control
                        name="password"
                        placeholder="Password"
                        type={visible ? "text" : "password"}
                      />
                      <InputGroup.Button onClick={handleChange}>
                        {visible ? <EyeIcon /> : <EyeSlashIcon />}
                      </InputGroup.Button>
                    </div>
                  </Form.Group>
                  <Form.Group>
                    <ButtonToolbar className="space-between">
                      <Button
                        appearance="primary"
                        type="submit"
                        loading={loading}
                      >
                        {t("LOGIN")}
                      </Button>
                      <Button
                        appearance="link"
                        onClick={() => navigate(GlobalRoutes.ForgotPassword)}
                      >
                        {t("FORGOT_PASSWORD")}
                      </Button>
                    </ButtonToolbar>
                    {error && <Message type="error">{error}</Message>}
                  </Form.Group>
                </Form>
              </Panel>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Content>
      </Container>
    </div>
  );
}
